/* eslint-disable max-len */
/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import {
  Typography,
  Button,
  Switch,
  FormControl,
  MenuItem,
} from '@material-ui/core';
import SelectMUI from '@material-ui/core/Select';
import Select from 'react-select';
import EditIcon from '@material-ui/icons/Edit';
import PropTypes from 'prop-types';
import MomentUtils from '@date-io/moment';
import AsyncSelect from 'react-select/async';
import {
  KeyboardDatePicker,
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import semesterServices from '../../redux/services/semesterServices';
import examSubjectServices from '../../redux/services/examSubjectServices';
import useUpdateExam from './useUpdateExam';
import { toastSuccess } from '../../redux/actions/alertActions';

const ExamUpdate = ({
  data, closeModal, setExamData, examData,
}) => {
  const [catchUp, setCatchUp] = useState(false);
  const [modality, setModality] = useState({ value: '', label: '' });
  const [modalities, setModalities] = useState([]);
  const [examSubject, setExamSubject] = useState({});
  const [examBegin, setExamBegin] = useState(new Date());
  const [examEnd, setExamEnd] = useState(new Date());
  const [EWCorrect, setEWCorrect] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState(new Date());
  const [time, setTime] = useState(data.durations ? data.durations : 60);
  const [examSubjects, setExamSubjects] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const { updateExam } = useUpdateExam();

  const update = () => {
    const newData = {
      catchUp,
      modality,
      examSubject,
      deliveryDate,
      examBegin: new Date(examBegin),
      examEnd: new Date(examEnd),
      EWCorrect,
      duration: time,
    };
    updateExam(data.examId, newData, semesters);
    toastSuccess('Examen mis à jour');
    const examDataArr = [...examData];
    examDataArr.forEach((item, index) => {
      if (item.examId === data.examId) {
        examDataArr.splice(index, 1, { ...data, ...newData });
      }
    });
    setExamData(examDataArr);
    closeModal();
  };

  const handleChange = (name) => (event) => {
    if (name === 'examBegin') setExamBegin(event);
    else if (name === 'examEnd') setExamEnd(event);
    else if (name === 'modality') setModality(event);
    else if (name === 'examSubject') setExamSubject(event);
    else if (name === 'deliveryDate') setDeliveryDate(event._d);
  };

  useEffect(() => {
    examSubjectServices.getAllExamSubjects().then((res) => {
      res.push({ name: 'Sur table' });
      res.push({ name: 'Oral' });
      setExamSubjects(res);
      res.forEach((subject) => {
        if (subject._id === data.examSubjectId) {
          setExamSubject(subject);
        }
      });
    });
    semesterServices.getAllSemesters()
      .then((semestersList) => {
        setSemesters(semestersList);
        semestersList.forEach((sem) => {
          if (sem.value === data.semester) {
            if (sem.examModalities) {
              setModalities([
                ...sem.examModalities,
                { label: 'Oral : Role Play', value: 'Oral : Role Play' },
                { label: 'Oral : Case study', value: 'Oral : Case study' },
                { label: 'Oral : Poster Presentation', value: 'Oral : Poster Presentation' },
              ]);

              sem.examModalities.forEach((item) => {
                if (item.label === data.examModality) {
                  setModality(item);
                }
              });
            }
          }
        });
      });
    setExamBegin(data.examBegin);
    setExamEnd(data.examEnd);
    setCatchUp(data.catchUp);
    setEWCorrect(data.EWCorrect);
    const tmp = new Date(data.endDate);
    tmp.setDate(tmp.getDate() + 21);
    setDeliveryDate(data.deliveryDate || tmp);
  }, [data]);

  return (
    <>
      <Row style={{ height: '400px' }}>
        <Col md={6}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Modalité d&apos;examen
          </Typography>
          <Select
            value={modality}
            placeholder={modality}
            options={modalities}
            onChange={handleChange('modality')}
          />
        </Col>
        <Col md={6}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Sujet
          </Typography>
          <AsyncSelect
            value={examSubject}
            placeholder="Type to search a file.."
            defaultOptions={examSubjects}
            getOptionLabel={(option) => option.name}
            onChange={(e) => {
              setExamSubject(e);
            }}
          />
        </Col>
        <Col md={6}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Date et heure du début de l&apos;examen
          </Typography>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDateTimePicker
              required
              autoOk
              inputMode="none"
              fullWidth
              format="DD/MM - HH:mm"
              onChange={handleChange('examBegin')}
              value={examBegin}
              helperText="Date et heure de début de l'examen"
            />
          </MuiPickersUtilsProvider>
        </Col>
        <Col md={6}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Date et heure de fin de l&apos;examen
          </Typography>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDateTimePicker
              required
              autoOk
              inputMode="none"
              fullWidth
            //   error={errors.beginDate}
              format="DD/MM - HH:mm"
              onChange={handleChange('examEnd')}
              value={examEnd}
              helperText="Date et heure de fin de l'examen"
            />
          </MuiPickersUtilsProvider>
        </Col>
        {(modality.value !== 'Quiz automatisé')
       && (
       <Col md={3}>
         <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
           Évaluation corrigée par EnglishWorld ?
         </Typography>
         <Switch
           checked={EWCorrect}
           onChange={() => setEWCorrect(!EWCorrect)}
           color="primary"
         />
       </Col>
       )}
        {EWCorrect
          ? (
            <Col md={3}>
              <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
                Date de rendu des copies
              </Typography>
              <MuiPickersUtilsProvider
                utils={MomentUtils}
                locale="fr"
                style={{
                  marginTop: '20px',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <KeyboardDatePicker
                  required
                  autoOk
                  inputMode="none"
                  // minDate={minimumDeliveryDate}
                  disablePast
                  InputProps={{ readOnly: true }}
                  format="DD/MM/YYYY"
                  fullWidth
                  onChange={handleChange('deliveryDate')}
                  value={deliveryDate}
                  helperText="Date de retour des notes"
                />
              </MuiPickersUtilsProvider>
            </Col>
          )
          : null}
        <Col md={3}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Durée de l&apos;examen
          </Typography>
          <FormControl style={{ marginBottom: '30px' }}>
            <SelectMUI
              id="demo-simple-select-label"
              onChange={(e) => setTime(e.target.value)}
              value={time}
            >
              <MenuItem value={60}>1h</MenuItem>
              <MenuItem value={90}>1h30</MenuItem>
            </SelectMUI>
          </FormControl>
        </Col>
        <Col md={3}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Rattrapage ?
          </Typography>
          <Switch
            checked={catchUp}
            onChange={() => setCatchUp(!catchUp)}
            color="primary"
          />
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <Button
            onClick={() => update()}
            style={{ marginTop: '3.3em', padding: '1em 0 1em 0' }}
            variant="contained"
            color="primary"
            startIcon={<EditIcon>Update</EditIcon>}
            fullWidth
          >
            Mettre à jour
          </Button>
        </Col>
      </Row>
    </>
  );
};

ExamUpdate.propTypes = {
  data: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
  updateExam: PropTypes.func.isRequired,
  semestersList: PropTypes.array.isRequired,
};

export default ExamUpdate;
